// extracted by mini-css-extract-plugin
module.exports = {"header":"ChangeCocFormModal_header_2udLU","closeIcon":"ChangeCocFormModal_closeIcon_5L0Lj"};